import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const frameSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.brand,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.templeType,
  SpecificationsLibrary.opcoBackendIdArticleNumber,
]

export const sunglassesSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.brand,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.polarized,
  SpecificationsLibrary.prescriptionGlass,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.templeType,
  SpecificationsLibrary.opcoBackendIdArticleNumber,
  SpecificationsLibrary.trend,
  SpecificationsLibrary.roadworthiness,
]
